import { createContext, useContext } from 'react';

export interface BoostControl {
    /** The image has already been upscaled, so the control offers the comparison. */
    wasUpscaled: boolean;
    /** Runs the boost, or reopens the comparison for an image already boosted. */
    activate: () => void;
}

/**
 * The boost trigger, offered to whatever draws the picture's controls.
 *
 * Boost used to carry its own bar. Centred along the foot to dodge the hover
 * panel's More, it then ran into the panel's own tools on any tile narrow
 * enough for the two to meet, and the label clipped. The workflow around it —
 * the loading overlay, the before-and-after curtain — still belongs to the
 * overlay; only the button it opens with moves, into the row the picture's
 * other tools already sit in.
 *
 * Null when the reader cannot boost, which is almost everyone: it is staff-only
 * and behind a flag.
 */
const BoostControlContext = createContext<BoostControl | null>(null);

export const BoostControlProvider = BoostControlContext.Provider;

/** The boost trigger for the picture being drawn, if there is one. */
export const useBoostControl = (): BoostControl | null =>
    useContext(BoostControlContext);
